import styled from 'styled-components';

export const Main = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;
